<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBK Call Request</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <router-link to="/tbk_claim">
        TBK
      </router-link>
      /

      <router-link to="/tbk_call_request">
        Call Requests
      </router-link>
      /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- TBA -->
        <div class="card text-left">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <h4 class="card-title mb-3">
                Call Log
              </h4>
              <button class="btn btn-primary" @click="handleAdd">
                Add New
              </button>
            </div>
            <div class="">
              <p>
                Customer's Name:
                <span style="color: #AC8400;">{{ call.customer_name }}</span>
              </p>
              <p>
                Product: <span style="color: #AC8400;">{{ call.product }}</span>
              </p>
            </div>

            <div class="table-responsive">
              <table
                id="call_log_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Agent Name</th>
                    <th>Date</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in call_log" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.staff }}</td>
                    <td>{{ item.date }}</td>
                    <td>{{ item.remark }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div
      class="modal fade"
      :class="{ show: isModalVisible }"
      tabindex="-1"
      role="dialog"
      style="display: block;background-color: rgba(0, 0, 0, 0.5);"
      v-if="isModalVisible"
      @click.self="closeModal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header justify-content-center">
            <h5 class="modal-title text-primary text-center">Call Log</h5>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <label for="remark">Remark</label>
            <textarea
              id="remark"
              @input="onChange"
              type="text"
              ref="modalInput"
              class="form-control"
              placeholder=""
            ></textarea>
            <div v-if="error">
              <small class="text-danger">{{ error }}</small>
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer justify-content-center">
            <button
              type="button"
              class="btn border-primary text-primary"
              @click="closeModal"
            >
              Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="handleSubmit">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { error } from "jquery";
import { getCallLog, storeCallLog } from "../../services/CallService";

export default {
  name: "tbk_call_detail",

  data() {
    return {
      data: {
        remark: "",
        call_id: null
      },
      call: [],
      call_log: [],
      isModalVisible: false,
      error: null
    };
  },

  created() {
    this.data.call_id = this.$route.params.id;
  },

  watch: {
    call_log: {
      handler(newVal, oldVal) {
        this.destroyCallLogDatatable();
      },
      deep: true
    }
  },

  methods: {
    async fetchData() {
      try {
        const response = await getCallLog(this.$route.params.id);
        if (response.data.success) {
          this.call = response.data.call;
          this.call_log = response.data.call_logs;
        } else {
          console.error("API responded with success=false");
        }
      } catch (e) {
        console.error("Error occurred during fetchData:", e);
      }
    },

    closeModal() {
      this.isModalVisible = false;
    },

    handleAdd() {
      this.isModalVisible = true;
    },

    onChange(e) {
      this.data.remark = e.target.value;
    },

    async handleSubmit() {
      if (this.data.remark) {
        try {
          const response = await storeCallLog(this.$route.params.id, {
            remark: this.data.remark
          });

          if (response.data.success) {
            swal({
              title: "Success!",
              text: response.data.message,
              icon: "success"
            });
            this.isModalVisible = false;
            await this.fetchData();
          } else {
            swal({
              title: "Error!",
              text: response.data.message,
              icon: "error"
            });
          }
        } catch (e) {
          console.error(e);
        }
      } else {
        this.error = "Remark is required";
      }
    },

    loadDatatable(tableId) {
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`)
          .DataTable()
          .destroy();
      }

      $(`#${tableId}`).DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3]
            }
          }
        ]
      });
    },

    destroyCallLogDatatable() {
      ["call_log_tbl"].forEach(tableId => {
        if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
          $(`#${tableId}`)
            .DataTable()
            .destroy();
        }
      });

      this.$nextTick(() => {
        this.loadDatatable("call_log_tbl");
      });
    },

    loadTable() {
      $("#call_log_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: ["excel", "pdf"],
        bDestroy: true
      });
    }
  },

  async mounted() {
    await this.fetchData();
  }
};
</script>
